import { useActiveProduct } from '@shared/products-core';

export const useActiveProductContext = <Product,>() => {
    const product = useActiveProduct<Product>();
    const isProductAvailable = Boolean(product && Object.keys(product).length);

    return {
        product: isProductAvailable ? (product as Product) : undefined,
        isGlobalSearch: !isProductAvailable,
    };
};
